/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
    UserToJSONTyped,
} from './User';

/**
 * 
 * @export
 * @interface PasswordLoginResponse
 */
export interface PasswordLoginResponse {
    /**
     * 
     */
    user: User;
}

/**
 * Check if a given object implements the PasswordLoginResponse interface.
 */
export function instanceOfPasswordLoginResponse(value: object): value is PasswordLoginResponse {
    if (!('user' in value) || value['user'] === undefined) return false;
    return true;
}

export function PasswordLoginResponseFromJSON(json: any): PasswordLoginResponse {
    return PasswordLoginResponseFromJSONTyped(json, false);
}

export function PasswordLoginResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PasswordLoginResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'user': UserFromJSON(json['user']),
    };
}

export function PasswordLoginResponseToJSON(json: any): PasswordLoginResponse {
    return PasswordLoginResponseToJSONTyped(json, false);
}

export function PasswordLoginResponseToJSONTyped(value?: PasswordLoginResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user': UserToJSON(value['user']),
    };
}

